import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './app';
import {AuthProvider} from './auth/auth-context';
import reportWebVitals from './report-web-vitals';
import {initUtmCapture} from './libs/utm';
import {initAnalytics} from './libs/analytics';

initUtmCapture();
initAnalytics();

const root = ReactDOM.createRoot(document.querySelector('#root')!);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
void reportWebVitals();
